import { LuChevronLeft, LuChevronRight, LuEye, LuFileOutput } from "react-icons/lu";
import Button from "./Buttons";

export default function PurchaseOrderFooter({currentPage, canGoNext, submitting, onPrevious, onNext, onPreview, onSubmit}) {
  return (
    <div className="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex">
        {currentPage > 1 && (
          <Button variant="outline" icon={<LuChevronLeft size={14} />} onClick={onPrevious} >
            Previous
          </Button>
        )}
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        {currentPage < 5 && (
          <Button variant="solid" disabled={!canGoNext} onClick={onNext} >
            Next <LuChevronRight size={14} />
          </Button>
        )}

        {currentPage === 5 && (
          <>
            <Button variant="outline" icon={<LuEye size={14} />} onClick={onPreview} >
              Preview
            </Button>

            <Button variant="solid" icon={<LuFileOutput size={14} />} loading={submitting} onClick={onSubmit} >
              Send PO
            </Button>
          </>
        )}
      </div>
    </div>
  );
}